import Common from '../../../Common';

interface Browse {
	start?: string
	end?: string
	limit?: string | number
	limit_from?: string | number
	search?: string
	order_by?: string
	expand?: string
}

const Schedule = class extends Common {
	browse = (userId: id, data: Browse): CustomResponse<BrowseResponse & { schedules: Schedule[] }> =>
		this.get(`/user/${userId}/profile/schedule`, data)

	next = (userId: id) =>
		this.get(`/user/${userId}/profile/schedule/next`)
}

export default Schedule;
